import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import sanitizeHtml from "sanitize-html";
import { useSelector } from "react-redux";
import { StyleTypeContext } from "../umbilical_tools";
import jssVariables from "../jss_setup";
import { withRouter } from "react-router-dom";
import { usePropertyLangTag } from "../hooks";

const styles = createUseStyles({
  FAQ: (props) => ({
    textAlign: "center",
    display: "grid",
    gridGap: jssVariables.normal_gap,
    gridAutoRows: "max-content",
    padding: "0 5vw",
    paddingTop: `calc(9vh + ${jssVariables.normal_gap} * 2)`,
    paddingBottom: `calc(9vh + ${jssVariables.normal_gap} * 2)`,
    background: props.background,
    ..._.get(props, "customStyles.FAQ", {}),
  }),
  header: (props) => ({
    color: props.titleTextColor,
    ..._.get(props, "customStyles.header", {}),
  }),
  description: (props) => ({
    fontSize: "large",
    color: props.textColor,
    ..._.get(props, "customStyles.description", {}),
  }),
  termTitle: (props) => ({
    textAlign: "left",
    borderBottom: `2px solid ${props.baseColor}`,
    color: props.titleTextColor,
    ..._.get(props, "customStyles.termTitle", {}),
  }),
  termText: (props) => ({
    textAlign: "justify",
    color: props.textColor,
    fontSize: "larger",
    ..._.get(props, "customStyles.termText", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    FAQ: (props) => ({
      padding: jssVariables.spacing.center_margin_large,
      paddingTop: `calc(9vh + ${jssVariables.normal_gap} * 4)`,
      paddingBottom: `calc(9vh + ${jssVariables.normal_gap} * 4)`,
      ..._.get(props, "customStyles.FAQ.smallscreen", {}),
    }),
    termText: (props) => ({
      textAlign: "left",
      ..._.get(props, "customStyles.termText.smallscreen", {}),
    }),
  },
});
const FAQ = ({ baseColor, background, titleTextColor, textColor }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  var langTag = usePropertyLangTag();

  if (langTag === "_zh") {
    langTag = "_cn";
  } else if (langTag === "") {
    langTag = "_en";
  }

  const classes = styles({
    baseColor,
    background,
    titleTextColor,
    textColor,
    customStyles: cStyler({ type, brand, objName: "FAQ" }),
  });

  const { faq } = useSelector((state) => {
    const meta = state?.WebsiteMetadata?.metadata;
    return {
      faq: meta?.faq ?? {},
      faqs: meta?.faq?.questions_en ?? [],
      description: meta?.faq?.description_en ?? "",
    };
  });
  const faqs = faq?.[`questions${langTag}`] ?? [];
  const description = faq?.[`description${langTag}`] ?? "";

  return (
    <faq className={classes.FAQ}>
      <h1 className={classes.header}>FAQ</h1>
      <div
        className={classes.description}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml((description ?? "").replaceAll("&nbsp;", " ")),
        }}
      />
      {faqs.map((faq, idx) => (
        <React.Fragment key={idx}>
          <h4 className={classes.termTitle}>
            {idx + 1}. {(faq.question ?? "").replaceAll("&nbsp;", " ")}
          </h4>
          <div
            className={classes.termText}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                (faq.answer ?? "").replaceAll("&nbsp;", " ")
              ),
            }}
          />
        </React.Fragment>
      ))}
    </faq>
  );
};
FAQ.defaultProps = {
  baseColor: "black",
  background: "white",
  textColor: "black",
  titleTextColor: "black",
};
FAQ.propTypes = {
  baseColor: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  titleTextColor: PropTypes.string.isRequired,
};
export default withRouter(FAQ);
